import { Component, Inject, Input, Signal, signal, WritableSignal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import { DialogData } from 'src/app/shared/components/dialogs/get-time/get-time.component';
import { CommonModule } from '@angular/common';
import { IControlliEffettuati, IPuntoCampionamento } from '../../punti-campionamento.model';
import { PuntiCampionamentoService } from '../../punti-campionamento.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { TableComponent } from "../../../../shared/components/table/table.component";
import { ControlloDettaglioService } from '../../controllo-dettaglio.service';
import { ITableColumn } from 'src/app/core/models/table.model';
import { CONTROLLO_DETTAGLIO_COLUMNS } from '../../controlli-dettaglio.config';
import {NgxPrintModule} from 'ngx-print';
import {MatButtonModule} from '@angular/material/button';
@Component({
  selector: 'app-my-dialog-controlli',
  standalone: true,
  imports: [
    MatDialogModule,
    MyButtonComponent,
    CommonModule,
    TableComponent,
    NgxPrintModule,
    MatButtonModule
],
  templateUrl: './my-dialog-controlli.component.html',
  styleUrl: './my-dialog-controlli.component.css'
})
export class MyDialogControlliComponent {
  datiControlli:Signal<IControlliEffettuati[]>=signal([]);
  columnsControlli: ITableColumn[] = CONTROLLO_DETTAGLIO_COLUMNS;
  constructor(
    public dialogRef: MatDialogRef<MyDialogControlliComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: DialogData | any,
    public readonly controlloDettaglioService: ControlloDettaglioService,

  ) {
    this.datiControlli = toSignal(this.controlloDettaglioService.getControlliDettaglio(this.data.idPuntoCampionamento), { initialValue: [] });
   
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
